import { createActions, createReducer } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    createListingRequest: ['formData'],
    createVideoListingRequest: ['formData'],
    createListingWithVideoUrlRequest: ['payload'],
    presignVideoRequest: ['payload'],
    fetchingUserListingsRequest: ['options'],
    fetchingSingleListingRequest: ['id'],
    fetchingAgentListingsRequest: ['agentId', 'options', 'isPublic'],
    fetchingAllListingsRequest: ['options'],
    updatingListingVacancyRequest: ['listingId', 'vacancy', 'tillWhenDate'],
    updatingListingPriceRequest: ['listingId', 'price'],
    updatingAvailableRoomsRequest: ['listingId', 'availableRooms'],
    updatingUnitVacancyRequest: ['listingId', 'unitId', 'vacancy', 'tillWhenDate'],
    updatingUnitPriceRequest: ['listingId', 'unitId', 'price'],
    searchingListingsRequest: ['query', 'filters', 'page', 'size', 'isPublic'],
    searchingAgentDataListingsRequest: ['agentId', 'query', 'filters', 'page', 'size', 'isPublic'],
    searchingListingsByDateRangeRequest: ['vacancy', 'tillWhenDateFrom', 'tillWhenDateTo', 'page', 'size'],
    uploadListingVideoRequest: ['listingId', 's3Key', 'title'],
    updateListingVideoFileRequest: ['listingId', 'file', 'title'],
    updateListingVideoUrlRequest: ['listingId', 'videoUrl'],
    updateListingVideoProgress: ['progress'],
    uploadStatusRequest: ['jobId'],

    createListingSuccess: ['listing'],
    createVideoListingSuccess: ['listing'],
    createListingWithVideoUrlSuccess: ['listing'],
    presignVideoSuccess: ['data'],
    userListingsSuccess: ['listings'],
    agentListingsSuccess: ['listings'],
    fetchingAllListingsSuccess: ['listings'],
    fetchingSingleListingSuccess: ['listings'],
    updatingListingVacancySuccess: ['value'],
    updatingListingPriceSuccess: ['value'],
    updatingAvailableRoomsSuccess: ['value'],
    updatingUnitVacancySuccess: ['value'],
    updatingUnitPriceSuccess: ['value'],
    searchingListingsSuccess: ['data'],
    searchingAgentDataListingsSuccess: ['data'],
    searchingListingsByDateRangeSuccess: ['data'],
    uploadListingVideoSuccess: ['data'],
    updateListingVideoUrlSuccess: ['data'],
    uploadStatusSuccess: ['data'],

    createListingFailure: ['error'],
    createVideoListingFailure: ['error'],
    createListingWithVideoUrlFailure: ['error'],
    presignVideoFailure: ['error'],
    fetchingUserListingsFailure: ['error'],
    fetchingSingleListingFailure: ['error'],
    fetchingAgentListingsFailure: ['error'],
    fetchingAllListingsFailure: ['error'],
    updatingListingVacancyFailure: ['error'],
    updatingListingPriceFailure: ['error'],
    updatingAvailableRoomsFailure: ['error'],
    updatingUnitVacancyFailure: ['error'],
    updatingUnitPriceFailure: ['error'],
    searchingListingsFailure: ['error'],
    searchingAgentDataListingsFailure: ['error'],
    searchingListingsByDateRangeFailure: ['error'],
    uploadListingVideoFailure: ['error'],
    updateListingVideoUrlFailure: ['error'],
    uploadStatusFailure: ['error'],
})

export const ListingsTypes = Types
export const ListingsActions = Creators

/* ------------- Initial State ------------- */

const INITIAL_STATE = {
    creatingListing: false,
    creatingVideoListing: false,
    creatingListingWithVideoUrl: false,
    presigningVideo: false,
    fetchingUserListings: false,
    fetchingSingleListing: false,
    fetchingAgentListings: false,
    fetchingAllListings: false,
    updatingListingVacancy: false,
    updatingListingPrice: false,
    updatingAvailableRooms: false,
    updatingUnitVacancy: false,
    updatingUnitPrice: false,
    searching: false,
    searchingAgentData: false,
    searchingByDateRange: false,
    uploadingListingVideo: false,
    updatingListingVideoUrl: false,
    uploadVideoProgress: 0,
    uploadingStatus: false,

    createListingSuccess: null,
    createVideoListingSuccess: null,
    createListingWithVideoUrlSuccess: null,
    presignVideoSuccess: null,
    userListingsSuccess: null,
    singleListingSuccess: null,
    agentListingsSuccess: null,
    allListingsSuccess: null,
    updateListingVacancySuccess: null,
    updateListingPriceSuccess: null,
    updateAvailableRoomsSuccess: null,
    updateUnitVacancySuccess: null,
    updateUnitPriceSuccess: null,
    searchSuccess: null,
    searchAgentDataSuccess: null,
    searchByDateRangeSuccess: null,
    uploadListingVideoSuccess: null,
    updateListingVideoUrlSuccess: null,
    uploadStatusSuccess: null,

    createListingError: null,
    createVideoListingError: null,
    createListingWithVideoUrlError: null,
    presignVideoError: null,
    userListingsFailure: null,
    singleListingFailure: null,
    agentListingsFailure: null,
    allListingsFailure: null,
    updatingListingVacancyFailure: null,
    updatingListingPriceFailure: null,
    updatingAvailableRoomsFailure: null,
    updatingUnitVacancyFailure: null,
    updatingUnitPriceFailure: null,
    searchFailure: null,
    searchAgentDataFailure: null,
    searchByDateRangeFailure: null,
    uploadListingVideoFailure: null,
    updateListingVideoUrlFailure: null,
    uploadStatusFailure: null

}

/* ------------- Reducers ------------- */

//request
const createListingRequest = (state) => ({
    ...state, creatingListing: true, createListingSuccess: null, createListingError: null,
})

const createVideoListingRequest = (state) => ({
    ...state, creatingVideoListing: true, createVideoListingSuccess: null, createVideoListingError: null,
})

const createListingWithVideoUrlRequest = (state) => ({
    ...state, creatingListingWithVideoUrl: true, createListingWithVideoUrlSuccess: null, createListingWithVideoUrlError: null,
})

const presignVideoRequest = (state) => ({
    ...state, presigningVideo: true, presignVideoSuccess: null, presignVideoError: null,
    createVideoListingSuccess: null, createVideoListingError: null,
})

const fetchingUserListingsRequest = (state) => ({
    ...state, fetchingUserListings: true, userListingsSuccess: null
})

const fetchingSingleListingRequest = (state) => ({
    ...state, fetchingSingleListing: true, singleListingSuccess: null
})

const fetchingAgentListingsRequest = (state) => ({
    ...state, fetchingAgentListings: true, agentListingsSuccess: null
})

const fetchingAllListingsRequest = (state) => ({
    ...state, fetchingAllListings: true, allListingsSuccess: null
})

const updatingListingVacancyRequest = (state) => ({
    ...state, updatingListingVacancy: true, updateListingVacancySuccess: null
})

const updatingListingPriceRequest = (state) => ({
    ...state, updatingListingPrice: true, updateListingPriceSuccess: null
})

const updatingAvailableRoomsRequest = (state) => ({
    ...state, updatingAvailableRooms: true, updateAvailableRoomsSuccess: null
})

const updatingUnitVacancyRequest = (state) => ({
    ...state, updatingUnitVacancy: true, updateUnitVacancySuccess: null
})

const updatingUnitPriceRequest = (state) => ({
    ...state, updatingUnitPrice: true, updateUnitPriceSuccess: null
})

const searchingListingsRequest = (state) => ({
    ...state, searching: true, searchSuccess: null
})

const searchingAgentDataListingsRequest = (state) => ({
    ...state, searchingAgentData: true, searchAgentDataSuccess: null
})

const searchingListingsByDateRangeRequest = (state) => ({
    ...state, searchingByDateRange: true, searchByDateRangeSuccess: null, searchByDateRangeFailure: null
})

const uploadListingVideoRequest = (state) => ({
    ...state, uploadingListingVideo: true, uploadListingVideoSuccess: null, uploadListingVideoFailure: null
})

const updateListingVideoFileRequest = (state) => ({
    ...state, uploadingListingVideo: true, uploadVideoProgress: 0, uploadListingVideoSuccess: null, uploadListingVideoFailure: null
})

const updateListingVideoUrlRequest = (state) => ({
    ...state, updatingListingVideoUrl: true, updateListingVideoUrlSuccess: null, updateListingVideoUrlFailure: null
})

const updateListingVideoProgress = (state, action) => ({
    ...state, uploadVideoProgress: action.progress,
})

const uploadStatusRequest = (state) => ({
    ...state, uploadingStatus: true, uploadStatusSuccess: null, uploadStatusFailure: null
})


//success
const createListingSuccess = (state, action) => {
    const { listing } = action
    return {
        ...state, creatingListing: false, createListingSuccess: listing, createListingError: null,
    }
}

const createVideoListingSuccess = (state, action) => {
    const { listing } = action
    return {
        ...state, creatingVideoListing: false, createVideoListingSuccess: listing, createVideoListingError: null,
    }
}

const createListingWithVideoUrlSuccess = (state, action) => {
    const { listing } = action
    return {
        ...state, creatingListingWithVideoUrl: false, createListingWithVideoUrlSuccess: listing, createListingWithVideoUrlError: null,
    }
}

const presignVideoSuccess = (state, action) => {
    const { data } = action
    return {
        ...state, presigningVideo: false, presignVideoSuccess: data, presignVideoError: null,
    }
}

const userListingsSuccess = (state, action) => {
    const { listings } = action;
    return {
        ...state, fetchingUserListings: false, userListingsSuccess: listings, userListingsFailure: null
    }
}

const fetchingSingleListingSuccess = (state, action) => {
    const { listings } = action;
    return {
        ...state, fetchingSingleListing: false, singleListingSuccess: listings, singleListingFailure: null
    }
}

const agentListingsSuccess = (state, action) => {
    const { listings } = action;
    return {
        ...state, fetchingAgentListings: false, agentListingsSuccess: listings, agentListingsFailure: null
    }
}

const fetchingAllListingsSuccess = (state, action) => {
    const { listings } = action;
    return {
        ...state, fetchingAllListings: false, allListingsSuccess: listings, allListingsFailure: null
    }
}
const updatingListingVacancySuccess = (state, action) => {
    const { value } = action;
    return {
        ...state, updatingListingVacancy: false, updateListingVacancySuccess: value, updatingListingVacancyFailure: null
    }
}

const updatingListingPriceSuccess = (state, action) => {
    const { value } = action;
    return {
        ...state, updatingListingPrice: false, updateListingPriceSuccess: value, updatingListingPriceFailure: null
    }
}

const updatingAvailableRoomsSuccess = (state, action) => {
    const { value } = action;
    return {
        ...state, updatingAvailableRooms: false, updateAvailableRoomsSuccess: value, updatingAvailableRoomsFailure: null
    }
}

const updatingUnitVacancySuccess = (state, action) => {
    const { value } = action;
    return {
        ...state, updatingUnitVacancy: false, updateUnitVacancySuccess: value, updatingUnitVacancyFailure: null
    }
}

const updatingUnitPriceSuccess = (state, action) => {
    const { value } = action;
    return {
        ...state, updatingUnitPrice: false, updateUnitPriceSuccess: value, updatingUnitPriceFailure: null
    }
}

const searchingListingsSuccess = (state, action) => {
    const { data } = action;
    return {
        ...state, searching: false, searchSuccess: data, successFailure: null
    }
}

const searchingAgentDataListingsSuccess = (state, action) => {
    const { data } = action;
    return {
        ...state, searchingAgentData: false, searchAgentDataSuccess: data, successAgentDataFailure: null
    }
}

const uploadStatusSuccess = (state, action) => {
    const { data } = action;
    return {
        ...state, uploadingStatus: false, uploadStatusSuccess: data, uploadStatusFailure: null
    }
}

const searchingListingsByDateRangeSuccess = (state, action) => {
    const { data } = action;
    return {
        ...state, searchingByDateRange: false, searchByDateRangeSuccess: data, searchByDateRangeFailure: null
    }
}

const uploadListingVideoSuccess = (state, action) => {
    const { data } = action;
    return {
        ...state, uploadingListingVideo: false, uploadVideoProgress: 0, uploadListingVideoSuccess: data, uploadListingVideoFailure: null
    }
}

const updateListingVideoUrlSuccess = (state, action) => {
    const { data } = action;
    return {
        ...state, updatingListingVideoUrl: false, updateListingVideoUrlSuccess: data, updateListingVideoUrlFailure: null
    }
}

//failure
const createListingFailure = (state, action) => {
    const { error } = action
    return {
        ...state, creatingListing: false, createListingSuccess: null, createListingError: error,
    }
}
const createVideoListingFailure = (state, action) => {
    const { error } = action
    return {
        ...state, creatingVideoListing: false, createVideoListingSuccess: null, createVideoListingError: error,
    }
}

const createListingWithVideoUrlFailure = (state, action) => {
    const { error } = action
    return {
        ...state, creatingListingWithVideoUrl: false, createListingWithVideoUrlSuccess: null, createListingWithVideoUrlError: error,
    }
}

const presignVideoFailure = (state, action) => {
    const { error } = action
    return {
        ...state, presigningVideo: false, presignVideoSuccess: null, presignVideoError: error,
    }
}

const fetchingUserListingsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, fetchingUserListings: false, userListingsSuccess: null, fetchingUserListingsFailure: error
    }
}

const fetchingSingleListingFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, fetchingSingleListing: false, singleListingSuccess: null, singleListingFailure: error
    }
}

const fetchingAgentListingsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, fetchingAgentListings: false, agentListingsSuccess: null, agentListingsFailure: error
    }
}

const fetchingAllListingsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, fetchingAllListings: false, allListingsSuccess: null, allListingsFailure: error
    }
}

const updatingListingVacancyFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, updatingListingVacancy: false, updateListingVacancySuccess: null, updatingListingVacancyFailure: error
    }
}

const updatingListingPriceFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, updatingListingPrice: false, updateListingPriceSuccess: null, updatingListingPriceFailure: error
    }
}

const updatingAvailableRoomsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, updatingAvailableRooms: false, updateAvailableRoomsSuccess: null, updatingAvailableRoomsFailure: error
    }
}

const updatingUnitVacancyFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, updatingUnitVacancy: false, updateUnitVacancySuccess: null, updatingUnitVacancyFailure: error
    }
}

const updatingUnitPriceFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, updatingUnitPrice: false, updateUnitPriceSuccess: null, updatingUnitPriceFailure: error
    }
}

const searchingListingsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, searching: false, searchSuccess: null, searchFailure: error
    }
}

const searchingAgentDataListingsFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, searchingAgentData: false, searchAgentDataSuccess: null, searchAgentDataFailure: error
    }
}

const uploadStatusFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, uploadingStatus: false, uploadStatusSuccess: null, uploadStatusFailure: error
    }
}

const searchingListingsByDateRangeFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, searchingByDateRange: false, searchByDateRangeSuccess: null, searchByDateRangeFailure: error
    }
}

const uploadListingVideoFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, uploadingListingVideo: false, uploadVideoProgress: 0, uploadListingVideoSuccess: null, uploadListingVideoFailure: error
    }
}

const updateListingVideoUrlFailure = (state, action) => {
    const { error } = action;
    return {
        ...state, updatingListingVideoUrl: false, updateListingVideoUrlSuccess: null, updateListingVideoUrlFailure: error
    }
}

export default createReducer(INITIAL_STATE, {
    [Types.CREATE_LISTING_REQUEST]: createListingRequest,
    [Types.CREATE_VIDEO_LISTING_REQUEST]: createVideoListingRequest,
    [Types.CREATE_LISTING_WITH_VIDEO_URL_REQUEST]: createListingWithVideoUrlRequest,
    [Types.PRESIGN_VIDEO_REQUEST]: presignVideoRequest,
    [Types.FETCHING_USER_LISTINGS_REQUEST]: fetchingUserListingsRequest,
    [Types.FETCHING_AGENT_LISTINGS_REQUEST]: fetchingAgentListingsRequest,
    [Types.FETCHING_ALL_LISTINGS_REQUEST]: fetchingAllListingsRequest,
    [Types.UPDATING_LISTING_VACANCY_REQUEST]: updatingListingVacancyRequest,
    [Types.UPDATING_LISTING_PRICE_REQUEST]: updatingListingPriceRequest,
    [Types.UPDATING_AVAILABLE_ROOMS_REQUEST]: updatingAvailableRoomsRequest,
    [Types.UPDATING_UNIT_VACANCY_REQUEST]: updatingUnitVacancyRequest,
    [Types.UPDATING_UNIT_PRICE_REQUEST]: updatingUnitPriceRequest,
    [Types.SEARCHING_LISTINGS_REQUEST]: searchingListingsRequest,
    [Types.SEARCHING_AGENT_DATA_LISTINGS_REQUEST]: searchingAgentDataListingsRequest,
    [Types.SEARCHING_LISTINGS_BY_DATE_RANGE_REQUEST]: searchingListingsByDateRangeRequest,
    [Types.UPLOAD_LISTING_VIDEO_REQUEST]: uploadListingVideoRequest,
    [Types.UPDATE_LISTING_VIDEO_FILE_REQUEST]: updateListingVideoFileRequest,
    [Types.UPDATE_LISTING_VIDEO_URL_REQUEST]: updateListingVideoUrlRequest,
    [Types.UPDATE_LISTING_VIDEO_PROGRESS]: updateListingVideoProgress,
    [Types.UPLOAD_STATUS_REQUEST]: uploadStatusRequest,
    [Types.FETCHING_SINGLE_LISTING_REQUEST]: fetchingSingleListingRequest,

    [Types.CREATE_LISTING_SUCCESS]: createListingSuccess,
    [Types.CREATE_VIDEO_LISTING_SUCCESS]: createVideoListingSuccess,
    [Types.CREATE_LISTING_WITH_VIDEO_URL_SUCCESS]: createListingWithVideoUrlSuccess,
    [Types.PRESIGN_VIDEO_SUCCESS]: presignVideoSuccess,
    [Types.USER_LISTINGS_SUCCESS]: userListingsSuccess,
    [Types.AGENT_LISTINGS_SUCCESS]: agentListingsSuccess,
    [Types.FETCHING_ALL_LISTINGS_SUCCESS]: fetchingAllListingsSuccess,
    [Types.UPDATING_LISTING_VACANCY_SUCCESS]: updatingListingVacancySuccess,
    [Types.UPDATING_LISTING_PRICE_SUCCESS]: updatingListingPriceSuccess,
    [Types.UPDATING_AVAILABLE_ROOMS_SUCCESS]: updatingAvailableRoomsSuccess,
    [Types.UPDATING_UNIT_VACANCY_SUCCESS]: updatingUnitVacancySuccess,
    [Types.UPDATING_UNIT_PRICE_SUCCESS]: updatingUnitPriceSuccess,
    [Types.SEARCHING_LISTINGS_SUCCESS]: searchingListingsSuccess,
    [Types.SEARCHING_AGENT_DATA_LISTINGS_SUCCESS]: searchingAgentDataListingsSuccess,
    [Types.SEARCHING_LISTINGS_BY_DATE_RANGE_SUCCESS]: searchingListingsByDateRangeSuccess,
    [Types.UPLOAD_LISTING_VIDEO_SUCCESS]: uploadListingVideoSuccess,
    [Types.UPDATE_LISTING_VIDEO_URL_SUCCESS]: updateListingVideoUrlSuccess,
    [Types.UPLOAD_STATUS_SUCCESS]: uploadStatusSuccess,
    [Types.FETCHING_SINGLE_LISTING_SUCCESS]: fetchingSingleListingSuccess,


    [Types.CREATE_LISTING_FAILURE]: createListingFailure,
    [Types.CREATE_VIDEO_LISTING_FAILURE]: createVideoListingFailure,
    [Types.CREATE_LISTING_WITH_VIDEO_URL_FAILURE]: createListingWithVideoUrlFailure,
    [Types.PRESIGN_VIDEO_FAILURE]: presignVideoFailure,
    [Types.FETCHING_USER_LISTINGS_FAILURE]: fetchingUserListingsFailure,
    [Types.FETCHING_AGENT_LISTINGS_FAILURE]: fetchingAgentListingsFailure,
    [Types.FETCHING_ALL_LISTINGS_FAILURE]: fetchingAllListingsFailure,
    [Types.UPDATING_LISTING_VACANCY_FAILURE]: updatingListingVacancyFailure,
    [Types.UPDATING_LISTING_PRICE_FAILURE]: updatingListingPriceFailure,
    [Types.UPDATING_AVAILABLE_ROOMS_FAILURE]: updatingAvailableRoomsFailure,
    [Types.UPDATING_UNIT_VACANCY_FAILURE]: updatingUnitVacancyFailure,
    [Types.UPDATING_UNIT_PRICE_FAILURE]: updatingUnitPriceFailure,
    [Types.SEARCHING_LISTINGS_FAILURE]: searchingListingsFailure,
    [Types.SEARCHING_AGENT_DATA_LISTINGS_FAILURE]: searchingAgentDataListingsFailure,
    [Types.SEARCHING_LISTINGS_BY_DATE_RANGE_FAILURE]: searchingListingsByDateRangeFailure,
    [Types.UPLOAD_LISTING_VIDEO_FAILURE]: uploadListingVideoFailure,
    [Types.UPDATE_LISTING_VIDEO_URL_FAILURE]: updateListingVideoUrlFailure,
    [Types.UPLOAD_STATUS_FAILURE]: uploadStatusFailure,
    [Types.FETCHING_SINGLE_LISTING_FAILURE]: fetchingSingleListingFailure,

})

